export default "__VITE_ASSET__BvP_fwse__"